module.exports = __webpack_public_path__ + "img/badge_tour.b736d4ab.jpg";